import classNames from 'classnames'
import style from 'components/Action.module.scss'
import Icons from 'components/Icons'
import { Link } from 'gatsby'
import React from 'react'

const Action = ({
  url,
  to,
  label,
  onClick,
  backgroundColor,
  icon,
  disabled,
}) => {
  const className = classNames(style.root, {
    [style.root___backgroundColor_white]: backgroundColor === 'white',
    [style.root___isDisabled]: disabled,
  })

  const Wrapper = ({ children }) => {
    if (onClick) {
      const handleClick = () => {
        return onClick()
      }

      return (
        <button className={className} type="button" onClick={handleClick}>
          {children}
        </button>
      )
    }

    if (to) {
      return (
        <Link to={to} className={className}>
          {children}
        </Link>
      )
    }

    return (
      <a href={url} target="_blank" rel="noreferrer" className={className}>
        {children}
      </a>
    )
  }

  const Icon = Icons[icon]

  return (
    <Wrapper>
      <div className={style.label}>{label}</div>
      <div className={style.icon}>
        <Icon />
      </div>
    </Wrapper>
  )
}

Action.defaultProps = {
  icon: 'ArrowRight',
}

export default Action
